<div ng-controller="setTaskAssigneeController as setAssigneeCtrl" class="modal-view activity-details solo">
    <c-auto-form config="setAssigneeCtrl.autoFormConfig"></c-auto-form>
</div>